import onboardingMessages from '@rhg/lang/messages/onboarding';
import {
    Box,
    Divider,
    Grid,
    Paper,
    SxProps,
    Theme,
    useMediaQuery,
    useTheme,
} from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { PodSection, PodSectionProps } from './section';

const stylePod = {
    px: { xs: 0, sm: 0, md: 0, lg: 6 },
};

const stylePodGrid = { width: '100%' };

const styleDivider = {
    height: { xs: 0, sm: 0, md: 0, lg: 'calc(100% - 48px)' },
    width: {
        xs: 'calc(100% - 48px)',
        sm: 'calc(100% - 48px)',
        md: 'calc(100% - 48px)',
        lg: 0,
    },
    m: 'auto',
};

const styleSectionContainer = {
    display: 'flex',
    height: '100%',
    width: '100%',
    flexDirection: {
        xs: 'column',
        sm: 'column',
        md: 'column',
        lg: 'row',
    },
};

export interface PodProps {
    sections: (PodSectionProps & { rawSection?: React.JSX.Element })[];
    sx?: SxProps<Theme>;
}
export function Pod({ sections, sx }: PodProps) {
    const { formatMessage } = useIntl();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    const numSections = useMemo(() => sections.length, [sections]);

    const dividerOrientation = useMemo(
        () => (isMobile ? 'horizontal' : 'vertical'),
        [isMobile]
    );

    return (
        <Paper
            sx={sxAppend(stylePod, sx)}
            data-testid={formatMessage(
                onboardingMessages['onboarding.screening.pod']
            )}
        >
            <Grid container sx={stylePodGrid}>
                {sections.map((section, i) => (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12 / numSections}
                        key={i}
                    >
                        <Box sx={styleSectionContainer}>
                            {section?.rawSection ? (
                                section?.rawSection
                            ) : (
                                <PodSection
                                    title={section.title}
                                    titleColor={section.titleColor}
                                    titleComponent={section.titleComponent}
                                    subtitle={section.subtitle}
                                    subtitleColor={section.subtitleColor}
                                    icon={section.icon}
                                    sx={section.sx}
                                />
                            )}
                            {i < sections.length - 1 && (
                                <Divider
                                    sx={styleDivider}
                                    orientation={dividerOrientation}
                                />
                            )}
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
}
